import { Box } from '@mui/material';
import { SchoolPropertyCategory } from '@schooly/api';
import React, { FC, useMemo } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form-lts';

import {
  ModalContent,
  ModalMain,
} from '../../../../../components/uikit-components/Modal/Modal.styled';
import {
  SchoolTuneStatusesArchivable,
  SchoolTuneStatusesForm,
  SchoolTuneStatusModalMode,
} from './scheme';
import { SchoolTuneStatusesModalArrow } from './SchoolTuneStatusesModalArrow';
import { SchoolTuneStatusesModalCategoryBlock } from './SchoolTuneStatusesModalCategory';
import { getCategoriesByType, getSubCategories } from './utils';

export interface SchoolTuneStatusesModalMainPanelProps extends SchoolTuneStatusesArchivable {
  type: SchoolTuneStatusModalMode;
  leavingStatusId?: string;
  categories: SchoolPropertyCategory[];
}

export const SchoolTuneStatusesModalMainPanel: FC<SchoolTuneStatusesModalMainPanelProps> = ({
  type,
  showArchived,
  setShowArchived,
  autoSwitchedArchivedOn,
  leavingStatusId,
  categories,
}) => {
  const categoriesByType = useMemo(() => getCategoriesByType(categories), [categories]);

  const { control } = useFormContext<SchoolTuneStatusesForm>();
  const formFieldArray = useFieldArray({ control, name: type });

  return (
    <ModalMain>
      <ModalContent sx={{ pt: 0 }} active>
        <Box
          display="grid"
          gridTemplateColumns="1fr 29px 1fr 29px 1fr"
          gridTemplateRows="repeat(2, 1fr)"
          height="100%"
          gap={1}
          rowGap={2}
        >
          <Box gridColumn="span 1" gridRow="span 2" overflow="hidden">
            {categoriesByType.prospective && (
              <SchoolTuneStatusesModalCategoryBlock
                type={type}
                category={categoriesByType.prospective}
                showArchived={showArchived}
                setShowArchived={setShowArchived}
                autoSwitchedArchivedOn={autoSwitchedArchivedOn}
                formFieldArray={formFieldArray}
                subCategories={
                  categoriesByType.prospective.id
                    ? getSubCategories(categoriesByType.prospective.id, categories)
                    : []
                }
              />
            )}
          </Box>
          <Box gridColumn="span 1">
            <SchoolTuneStatusesModalArrow />
          </Box>
          <Box gridColumn="span 1" overflow="hidden">
            {categoriesByType.current && (
              <SchoolTuneStatusesModalCategoryBlock
                type={type}
                category={categoriesByType.current}
                showArchived={showArchived}
                setShowArchived={setShowArchived}
                autoSwitchedArchivedOn={autoSwitchedArchivedOn}
                formFieldArray={formFieldArray}
              />
            )}
          </Box>
          <Box gridColumn="span 1">
            <SchoolTuneStatusesModalArrow />
          </Box>
          <Box gridColumn="span 1" overflow="hidden">
            {categoriesByType.former && (
              <SchoolTuneStatusesModalCategoryBlock
                type={type}
                category={categoriesByType.former}
                showArchived={showArchived}
                setShowArchived={setShowArchived}
                autoSwitchedArchivedOn={autoSwitchedArchivedOn}
                formFieldArray={formFieldArray}
                leavingStatusId={leavingStatusId}
              />
            )}
          </Box>
          <Box gridColumn="span 3" overflow="hidden">
            <SchoolTuneStatusesModalArrow />
          </Box>
          <Box gridColumn="span 1" overflow="hidden">
            {categoriesByType.unsuccessful && (
              <SchoolTuneStatusesModalCategoryBlock
                type={type}
                category={categoriesByType.unsuccessful}
                showArchived={showArchived}
                setShowArchived={setShowArchived}
                autoSwitchedArchivedOn={autoSwitchedArchivedOn}
                formFieldArray={formFieldArray}
              />
            )}
          </Box>
        </Box>
      </ModalContent>
    </ModalMain>
  );
};
